import {
  ButtonRoomControl,
  type ButtonRoomControlProps,
} from '@/components/ButtonRoomControl'
import { useSelfMemberState } from '@/hooks/useSelfMemberState'
import { useRoomStore, useRoomStoreActions } from '@/stores/room'

type OmittedProps = Omit<ButtonRoomControlProps, 'isActive' | 'onClick' | 'tag'>

type ButtonRaiseHandProps = OmittedProps

const ButtonRaiseHand = ({
  disabled = false,
  isVisible = true,
  ...props
}: ButtonRaiseHandProps) => {
  const memberId = useRoomStore(state => state.memberId)
  const selfHandRaised = useSelfMemberState({ subscriptionKey: 'handRaised' })

  const { handRaiseHandler } = useRoomStoreActions()

  return (
    <ButtonRoomControl
      isActive={selfHandRaised}
      disabled={disabled}
      isVisible={isVisible}
      onClick={() => handRaiseHandler(memberId)}
      // TODO: add disabled tag if needed
      tag={disabled ? 'back-hand' : 'back-hand'}
      {...props}
    >
      Raise Hand
    </ButtonRoomControl>
  )
}

export { ButtonRaiseHand }
